import { BaseModel } from '@shared/base/Base.Model';
import { IRestModel } from '@shared/interface/IRestModel';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';

export class BridgeAddressModel extends BaseModel implements IRestModel {

    public address: string = null;
    public readonly isIRestModel = true;

    public constructor() {
        super();
    }

    public loadFromRestApiModel(restModel: any): void {
        RestModelUtility.loadProperties(restModel, this, 'EM-BridgeAddressModel');
    }

    public toRestApiModel() {
        return RestModelUtility.toJson(this);
    }
}
